const WHITESPACE_REGEX = /^\s+|\s+$|\s{2,}/g;
const UNICODE_WHITESPACE = '\u00a0';

// Use unicode to render leading whitespaces, trailing whitespaces,
// and instances of more than one whitespace in an HTML element
export const unicodeWhitespaces = (s: string) =>
  s?.replace(WHITESPACE_REGEX, ({ length }) =>
    UNICODE_WHITESPACE.repeat(length)
  );
